import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  CompanyLoggedUserError,
  CompanyLoggedUserLoaded,
  CompanyLoggedUserRequested,
} from './company-users.actions';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from "../../@core/data/user/user.service";
import { ToastrConfigs } from "../../@core/data/toastr-config";
import { NbToastrService } from "@nebular/theme";
import { CompanyService } from '../../@core/data/company/company.service';

@Injectable()
export class CompanyUsersEffects {
  constructor(
    private actions$: Actions,
    private toastrService : NbToastrService,
    private companyService: CompanyService
  ) {}

  requestLoggedUser$ = createEffect(() => 
    this.actions$.pipe(
      ofType(CompanyLoggedUserRequested),
      mergeMap(() =>
        this.companyService.getLoggedUser().pipe(
          map((response: any) => CompanyLoggedUserLoaded({ loggedUser: response?.data })),
          catchError((error: any) => of(CompanyLoggedUserError()))
        ))
    )
  );
}
